import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { ChallengesStatuses, LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { AssetsService } from '@app/shared/services/assets.service';
import { LimitedTimeEventService } from '@app/shared/services/limitedTimeEvent.service';
import { AppService } from '@app/app.service';
import { Observable } from 'rxjs';
import { ProgressBarComponent } from '@app/shared/components/progress-bar/progress-bar.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { Throttle } from '@app/shared/decorators/throttle.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-adventure-quest-challenge-box',
  templateUrl: './adventure-quest-challenge-box.component.html',
  styleUrls: ['./adventure-quest-challenge-box.component.scss'],
  standalone: true,
  imports: [ProgressBarComponent, ButtonComponent, SharedModule],
})
export class AdventureQuestChallengeBoxComponent implements OnChanges {
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private assetsService = inject(AssetsService);
  private limitedTimeEventService = inject(LimitedTimeEventService);
  private appService = inject(AppService);

  @Input() event: LimitedTimeEvent;
  @Input() eventChallengeStatus: ChallengesStatuses;

  componentDestroy: () => Observable<unknown>;

  gameIcon: unknown;
  challengeText: string;
  showCompleted: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eventChallengeStatus) {
      this.eventChallengeStatus = changes.eventChallengeStatus.currentValue;
    }

    this.getGameIcon();
    this.manageChallengeText();
  }

  @Throttle(2000)
  goToGame(): void {
    this.eventManager
      .closeAllModals()
      .then(() => this.appService.showGame(this.eventChallengeStatus.gameId))
      .catch((e) => this.logger.error(e));
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.AdventureQuestModalComponent, ModalType.View));
  }

  private manageChallengeText(): void {
    this.challengeText = this.eventChallengeStatus
      ? this.limitedTimeEventService.getGameChallengeTransaltionKey(this.eventChallengeStatus)
      : '';
  }

  private getGameIcon(): void {
    this.gameIcon = {
      'background-image': `url('${this.assetsService.getGameIconUrl(this.eventChallengeStatus?.gameId)}')`,
    };
  }
}
